<template>
  <ion-page>
    <LargeNavbar @backButton="backButton" show-back-button is-large :title="t('profile.title')" />
    <ion-content>
      <div class="PageContainer mt-xs d-flex w-100">
        <div class="content w-100 px-sm mb-xs">
          <ProfileCard in-profile-view :expanded="false" />
        </div>
        <div class="content w-100">
          <ProfileMenu />
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>
<script setup lang="ts">
  import { IonContent, IonPage } from '@ionic/vue';
  import LargeNavbar from '@/components/LargeNavbar.vue';
  import ProfileCard from '@/components/shared/ProfileCard.vue';
  import { useI18n } from 'vue-i18n';
  import ProfileMenu from '@/components/shared/ProfileMenu.vue';
  import router from '@/router';

  const { t } = useI18n();

  const backButton = () => {
    router.back();
  };
</script>
<style scoped lang="scss"></style>
